import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

function ProgressSimple() {

	const params = useLocation();
	const pathname = params.pathname;
	const [items, setItems] = useState([
		{slug: '/aboutyou', name: 'About you' },
		{slug:'/details', name: 'Details of the person being referred'},
		{slug:'/reason-for-referral', name: 'Reason for referral'},
		{slug:'/submit', name: 'Submit form'}
	]);
	useEffect(() => {
		setItems(items.map(item => ({
			...item,
			isCurrent: item.slug === params.pathname
		})));
	}, [params.pathname]);

	return (
		<>
			{
				pathname === '/aboutyou' || pathname === '/details' || pathname === '/submit' || pathname === '/reason-for-referral' ?
				<section className="sectionOne">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-10">
								<div className="text">
									<h1 className="heading-large">Professionals: Make a social care referral for adults</h1>
								</div>
								<nav aria-label="form progress" className="lcc-progressIndicator">
									<ul className="nav nav-tabs mx-auto">
										{items.map((item, index) => (
											<li
												key={index}
												className={item.isCurrent ? 'progress--active' : null}
												aria-current={item.isCurrent ? 'page' : null}
											>
												{item.name}
											</li>
										))}
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</section>
			: ''
			}
		</>
	)
}
export default ProgressSimple;
